export const SEVERITY_LEVELS = ['DEFAULT', 'DEBUG', 'INFO', 'NOTICE', 'WARNING', 'ERROR', 'CRITICAL', 'ALERT', 'EMERGENCY'];

export const TIME_PRESETS = [
  { label: 'Last 1 hour', value: '1h', hours: 1 },
  { label: 'Last 6 hours', value: '6h', hours: 6 },
  { label: 'Last 12 hours', value: '12h', hours: 12 },
  { label: 'Last 24 hours', value: '1d', hours: 24 },
  { label: 'Last 2 days', value: '2d', hours: 48 },
  { label: 'Last 3 days', value: '3d', hours: 72 },
  { label: 'Last 5 days', value: '5d', hours: 120 },
  { label: 'Last 7 days', value: '7d', hours: 168 },
  { label: 'Last 30 days', value: '30d', hours: 720 },
  { label: 'Last 90 days', value: '90d', hours: 2160 },
  { label: 'Last 6 months', value: '6mo', hours: 4320 },
  { label: 'Custom range', value: 'custom', hours: 0 },
];

export function getPresetRange(hours) {
  const now = new Date();
  return {
    startTime: new Date(now.getTime() - hours * 60 * 60 * 1000).toISOString(),
    endTime: now.toISOString(),
  };
}

export function toLocalDatetimeString(isoString) {
  const d = new Date(isoString);
  const offset = d.getTimezoneOffset();
  const local = new Date(d.getTime() - offset * 60000);
  return local.toISOString().slice(0, 16);
}

export function getSeverityClass(severity) {
  const map = { EMERGENCY: 'severity-emergency', ALERT: 'severity-alert', CRITICAL: 'severity-critical', ERROR: 'severity-error', WARNING: 'severity-warning', NOTICE: 'severity-notice', INFO: 'severity-info', DEBUG: 'severity-debug' };
  return map[severity] || 'severity-default';
}

export function safeISOString(val) {
  if (!val) return '';
  try {
    const d = new Date(typeof val === 'object' && val.seconds ? val.seconds * 1000 : val);
    return isNaN(d.getTime()) ? String(val) : d.toISOString();
  } catch { return String(val); }
}

export function formatDate(dateValue) {
  if (!dateValue) return 'N/A';
  try {
    if (dateValue.seconds) return new Date(dateValue.seconds * 1000).toLocaleString();
    return new Date(dateValue).toLocaleString();
  } catch { return String(dateValue); }
}
